export default "__VITE_ASSET__hgLDjP95__"